export const CraftAgentIcon = (props: React.SVGProps<SVGSVGElement>) => (
  <svg
    width='24'
    height='24'
    viewBox='0 0 24 24'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
    {...props}
  >
    <path
      d='M14.3104 11.554C14.3104 12.8781 13.237 13.9515 11.9129 13.9515C10.5888 13.9515 9.51539 12.8781 9.51539 11.554C9.51539 10.2299 10.5888 9.15647 11.9129 9.15647C13.237 9.15647 14.3104 10.2299 14.3104 11.554Z'
      fill='currentColor'
    />
    <path
      d='M14.3104 4.48144C14.3104 5.80554 13.237 6.87893 11.9129 6.87893C10.5888 6.87893 9.51539 5.80554 9.51539 4.48144C9.51539 3.15735 10.5888 2.08395 11.9129 2.08395C13.237 2.08395 14.3104 3.15735 14.3104 4.48144Z'
      fill='currentColor'
    />
    <path
      d='M19.2366 10.094C18.0899 10.756 16.6236 10.3631 15.9616 9.21644C15.2995 8.06974 15.6924 6.60346 16.8391 5.94141C17.9858 5.27936 19.4521 5.67225 20.1141 6.81895C20.7762 7.96566 20.3833 9.43194 19.2366 10.094Z'
      fill='currentColor'
    />
    <path
      d='M16.8391 17.1665C15.6924 16.5044 15.2995 15.0382 15.9616 13.8915C16.6236 12.7448 18.0899 12.3519 19.2366 13.0139C20.3833 13.676 20.7762 15.1423 20.1141 16.289C19.4521 17.4357 17.9858 17.8285 16.8391 17.1665Z'
      fill='currentColor'
    />
    <path
      d='M14.3104 18.6265C14.3104 19.9506 13.237 21.024 11.9129 21.024C10.5888 21.024 9.51539 19.9506 9.51539 18.6265C9.51539 17.3024 10.5888 16.229 11.9129 16.229C13.237 16.229 14.3104 17.3024 14.3104 18.6265Z'
      fill='currentColor'
    />
    <path
      d='M6.98665 17.1665C5.83995 17.8285 4.37367 17.4357 3.71162 16.289C3.04957 15.1423 3.44246 13.676 4.58916 13.0139C5.73586 12.3519 7.20214 12.7448 7.86419 13.8915C8.52624 15.0382 8.13335 16.5044 6.98665 17.1665Z'
      fill='currentColor'
    />
    <path
      d='M4.58916 10.094C3.44246 9.43194 3.04957 7.96565 3.71162 6.81895C4.37367 5.67225 5.83995 5.27936 6.98665 5.94141C8.13335 6.60346 8.52624 8.06974 7.86419 9.21644C7.20214 10.3631 5.73586 10.756 4.58916 10.094Z'
      fill='currentColor'
    />
  </svg>
)
